import * as React from "react";
import { loadObjectAttrinbutesAll } from "src/pages/ManagementPage/objectsApi";
import { onError } from "src/common/onError";
import { makeFieldOptions } from "src/common/makeFieldOptions";
import { DefaultOptionType } from "antd/es/select";
import { ZAttribute } from "src/types/ZAttribute";
import { classNames } from "src/common/classNames";
import { ObjectO2 } from "src/pages/ManagementPage/Obj2Tab/Obj2Nodes";
import { Form, Select } from "antd";
import styles from "./BsObjectSection.module.less";

export type AttrDef = {
  label: string;
  attrName: string; // Имя поля в структуре данных, которое содержит attrId
  hidden?: boolean;
  attrValid?: (attr: ZAttribute) => boolean;
  onNewLine?: boolean;
  optional?: boolean; // Необязательное поле (большинство обязательные)
  CustomRender?: React.FC<PropsBsAttrSection>;
};
// CustomRender позволяет переделать выводимый контрол атрибута полностью или частично.
// Частичная переделка предполагает, что кастомный компонент модифицирует пропсы и вызывает AttrSection

export type PropsBsAttrSection = {
  attrDef: AttrDef;
  curObject: ObjectO2 | undefined;
  loading?: boolean;
};

/**
 * Выбор атрибута
 * Основной способ - через BsObjectSection.
 * Но требования постоянно усложняются. Например, в настройках КП2 (LPLM-5763) захотели вынести в отдельный блок
 * атрибуты от разных объектов.
 */
export const BsAttrSection: React.FC<PropsBsAttrSection> = (props) => {
  const { attrDef, curObject, loading } = props;
  const { attrName, label, attrValid, onNewLine, optional } = attrDef;
  const curObjectId = curObject?.object.id;
  const [attrOptions, setAttrOptions] = React.useState<DefaultOptionType[]>([]);
  const form = Form.useFormInstance();
  const load = async (): Promise<DefaultOptionType[]> => {
    if (!curObjectId) return [];
    // TODO: Тут можно было бы использовать какой-нибудь кеш, т.к. эти данные будут запрашивать сразу несколько полей.
    let list = await loadObjectAttrinbutesAll(curObjectId);
    if (attrValid) list = list.filter(attrValid);
    return makeFieldOptions(list);
  };
  // Попытка найти подходящее значение поля, используя имеющиеся данные.
  const autoComplete = (list: DefaultOptionType[]) => {
    let suitableOption: DefaultOptionType | undefined;
    if (list.length === 1) {
      // Если в списке один вариант, то подставляем его. Ведь всё равно других вариантов нет.
      [suitableOption] = list;
    } else {
      // Ищем вариант, где совпадает название поля и название атрибута
      suitableOption = list.find((opt) => opt.filterProp === label);
    }
    if (suitableOption) {
      form.setFieldValue(attrName, suitableOption.value);
    }
  };
  React.useEffect(() => {
    load()
      .then((list) => {
        setAttrOptions(list);
        if (!optional && !form.getFieldValue(attrName)) {
          // Автозаполнение выполняется для обязательных полей, если они не заполнены
          autoComplete(list);
        }
      })
      .catch(onError);
  }, [curObjectId]);
  return (
    <Form.Item
      key={attrName}
      label={label}
      name={attrName}
      rules={optional ? undefined : [{ required: true }]}
      className={classNames([[!!onNewLine, styles.onNewLine]])}
    >
      <Select
        allowClear
        options={attrOptions}
        showSearch
        placeholder="Выбрать"
        optionFilterProp="filterProp"
        loading={loading}
      />
    </Form.Item>
  );
};
